import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category', label: '影视分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const baseText = transparent ? 'text-background-50' : 'text-foreground-800';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur border-b border-background-200'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md text-lg ${
              transparent ? 'bg-background-50/15 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-film-line" />
          </span>
          <span className={`font-heading text-lg font-bold tracking-wide whitespace-nowrap ${baseText}`}>
            韩国伦理
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 absolute left-1/2 -translate-x-1/2">
          {navItems.map((item) => {
            const active =
              item.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-md text-sm transition-colors whitespace-nowrap ${
                  active
                    ? transparent
                      ? 'text-background-50 font-medium'
                      : 'text-primary-600 font-medium'
                    : transparent
                      ? 'text-background-100/85 hover:text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            className={`hidden sm:flex w-9 h-9 items-center justify-center rounded-md transition-colors ${
              transparent
                ? 'text-background-50 hover:bg-background-50/15'
                : 'text-foreground-600 hover:bg-background-100'
            }`}
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg" />
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md ${
              transparent ? 'text-background-50 hover:bg-background-50/15' : 'text-foreground-800 hover:bg-background-100'
            }`}
            aria-label="菜单"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-2">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="block px-2 py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 hover:text-primary-600"
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}